import type {StateCreator} from 'zustand'

export type ShowActionBarFn = (cellId: string) => void
export type HideActionBarFn = (cellId: string) => void
export type HideAllActionBarsFn = () => void

export interface ActionBarVisibilitySlice {
  actionBarVisibility: {
    activeActionBarCellId: string | null
  }
  showActionBar: ShowActionBarFn
  hideActionBar: HideActionBarFn
  hideAllActionBars: HideAllActionBarsFn
}

export const createActionBarVisibilitySlice =
  (): StateCreator<ActionBarVisibilitySlice, [['zustand/devtools', never]]> => set => ({
    actionBarVisibility: {
      activeActionBarCellId: null,
    },
    showActionBar: (cellId: string) =>
      set(
        () => ({actionBarVisibility: {activeActionBarCellId: cellId}}),
        undefined,
        `actionBarVisibility#show:${cellId}`,
      ),
    hideActionBar: (cellId: string) =>
      set(
        state => {
          // Only hide if this cellId is currently the active one (prevents race conditions)
          if (state.actionBarVisibility.activeActionBarCellId === cellId) {
            return {actionBarVisibility: {activeActionBarCellId: null}}
          }
          return state
        },
        undefined,
        `actionBarVisibility#hide:${cellId}`,
      ),
    hideAllActionBars: () =>
      set(() => ({actionBarVisibility: {activeActionBarCellId: null}}), undefined, `actionBarVisibility#hideAll`),
  })
